<div class="modal-content">
  <div class="modal-header">
    <h4>{{ this.title }}</h4>
  </div>
  <div class="modal-body">
    <p *ngIf="this.message">{{ this.message }}</p>
    <p *ngIf="this.description">{{ this.description }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" [ngClass]="['btn', this.cancelClass]" (click)="close()">{{ this.cancelText }}</button>
    <button type="button" [ngClass]="['btn', this.confirmClass]" (click)="confirm()">{{ this.confirmText }}</button>
  </div>
</div>
